// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

function withIsVisible(wrappedComponent) {
  function IsVisible({ isVisible, ...props }) {
    if (isVisible) {
      return tag(wrappedComponent, props)
    }
    return null
  }
  IsVisible.displayName = `IsVisible(${
    wrappedComponent.displayName ||
    wrappedComponent.name ||
    'Component'
  })`
  return IsVisible
}

module.exports = withIsVisible
